import { SharingRequest } from '@/model/SharingRequest';

import { BaseHttpController } from './BaseHttpController';

const endpoint = 'order';

export class OrderTrackingLinkController extends BaseHttpController {
  constructor() {
    super(endpoint);
  }

  async getAccessToken(orderId: number): Promise<string> {
    const response = await this.http.get<string>(
      `/${orderId}/tracking-link/token`,
    );
    return response.data;
  }

  async sendEmails(
    orderId: number,
    sharingRequest: SharingRequest,
  ): Promise<void> {
    await this.http.post<void>(
      `/${orderId}/tracking-link/email`,
      sharingRequest,
    );
  }
}
